import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

import styles from './edit-cell-popover.module.css';

interface HotelChannelPricingEditCellPopoverSignature {
  Args: {
    onPopoverToggle: (event: ToggleEvent) => void;
    popoverId: string;
  };
  Blocks: {
    default: [];
  };
}

const HotelChannelPricingEditCellPopover = <template>
  <div
    class="edit-cell-popover {{styles.popover}}"
    id={{@popoverId}}
    popover
    {{on "toggle" @onPopoverToggle}}
  >
    {{yield}}
  </div>
</template> satisfies TOC<HotelChannelPricingEditCellPopoverSignature>;

export default HotelChannelPricingEditCellPopover;
